import React, { useMemo, useState } from "react";
import InputComponent from "@ui/components/Input/Input.component";
import ModalComponent from "@ui/components/Modal/Modal.component";
import ButtonComponent from "@ui/components/Button/Button.component";
import ButtonBarComponent from "@ui/components/Button-bar/Button-bar.component";
import ModalFormComponent from "@ui/components/Modal-form/Modal-form.component";
import { IProps } from "./IProps";
import Box from "@mui/material/Box";
import { DataGrid, GridColDef, GridSelectionModel } from "@mui/x-data-grid";
import useDictionary from "@ui/hooks/useDictionary";
import SearchField from "@ui/components/Search-field/SearchField";

const Component: React.FC<IProps> = ({
    devices,
    lang,
    loading,
    imeiDevices,
    groupName,
    groupNameError,
    serverError,
    onGroupNameChange,
    onSaveClick,
    onInputClick,
    onKeyDown,
    onCheckedDevice,
    onBtnKeyDown,
    onClose,
}: IProps) => {
    const getWord = useDictionary();
    const devicesList = useMemo(
        () => devices.map(({ imei: value, name: label }) => ({ value, label })),
        [devices]
    );
    const [search, setSearch] = useState("");

    const filtredDeviceList = useMemo(
        () =>
            devicesList.filter((device) => {
                const isMatch =
                    device.label
                        .toString()
                        .toLocaleLowerCase()
                        .includes(search.toLocaleLowerCase()) ||
                    device.value
                        .toString()
                        .toLocaleLowerCase()
                        .includes(search.toLocaleLowerCase());

                return isMatch;
            }),
        [search]
    );

    const columns: GridColDef[] = [
        { field: "value", headerName: `${getWord("imei")}`, width: 200 },
        { field: "label", headerName: `${getWord("name")}`, width: 200 },
    ];
    return (
        <ModalComponent
            className="edit-group"
            title={getWord("addDeviceToGroup") + " " + groupName + "?"}
            alertText={serverError ? "serverError" : undefined}
            lang={lang}
            loading={loading}
            onBtnKeyDown={onBtnKeyDown}
            onClose={onClose}
        >
            <ModalFormComponent>
                <div style={{ height: 400, width: "100%" }}>
                    <div style={{ marginBottom: 10, width: "100%" }} className="modal__form">
                        <SearchField search={search} onSearch={setSearch} />
                    </div>
                    <DataGrid
                        loading={devicesList.length === 0}
                        getRowId={(row) => row.value}
                        rows={filtredDeviceList}
                        columns={columns}
                        checkboxSelection
                        disableColumnMenu
                        onSelectionModelChange={onCheckedDevice}
                    />
                </div>
            </ModalFormComponent>
            <div style={{ marginTop: "60px", width: "calc(100% - 80px)" }}>
            <ButtonBarComponent>
                <ButtonComponent
                    label="add"
                    lang={lang}
                    onClick={onSaveClick}
                    onKeyDown={onBtnKeyDown}
                />
                <ButtonComponent
                    color="error"
                    label="cancel"
                    lang={lang}
                    onClick={onClose}
                    onKeyDown={onBtnKeyDown}
                />
            </ButtonBarComponent>
            </div>
        </ModalComponent>
    );
};

const AddDeviceToGroupComponent = React.memo(Component);

export default AddDeviceToGroupComponent;
